(function() {
  function initMegaMenu() {
    document.addEventListener('click', function(e) {
      var tab = e.target.closest('.pf-mega__tab');
      if (!tab) return;
      var mega = tab.closest('.pf-mega');
      if (!mega) return;
      var panelId = 'panel-' + tab.dataset.panel;
      var targetPanel = mega.querySelector('#' + panelId);
      if (!targetPanel) return;
      mega.querySelectorAll('.pf-mega__tab').forEach(function(t) { t.classList.remove('pf-mega__tab--active'); });
      mega.querySelectorAll('.pf-mega__panel').forEach(function(p) { p.classList.remove('pf-mega__panel--active'); });
      tab.classList.add('pf-mega__tab--active');
      targetPanel.classList.add('pf-mega__panel--active');
    });

    document.addEventListener('pointerenter', function(e) {
      var tab = e.target.closest('.pf-mega__tab');
      if (tab) tab.click();
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenu);
  } else {
    initMegaMenu();
  }
})();